import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 15.5a.5 .5 0 0 1 .5 -.5h2a1.5 1.5 0 0 1 0 3h-1.167h1.167a1.5 1.5 0 0 1 0 3h-2a.5 .5 0 0 1 -.5 -.5","key":"svg-0"}],["path",{"d":"M5 12h14","key":"svg-1"}],["path",{"d":"M10 5l2 -2v6","key":"svg-2"}]]

const IconMath1Divide3 = createReactComponent('outline', 'math-1-divide-3', 'Math1Divide3', __iconNode);

export default IconMath1Divide3;